import { Dispatch } from "redux";
import { TWebsiteBuilderAction, WebsiteBuilderActionType } from "./websiteBuilderAction";
import { ISelectNodeActionPayload } from "./actions/node/selectNodeAction";
import { IUpdateSelectedNodeActionPayload } from "./actions/node/updateSelectedNode";
import { IDeleteNodeActionPayload } from "./actions/node/deleteNodeAction";
import { IMoveElementActionPayload } from "./actions/element/moveElementAction";
import { IAddNodeActionPayload } from "./actions/node/addNodeAction";
import { IResizeElementActionPayload } from "./actions/element/resizeElementAction";
import { IUpdateElementSettingsActionPayload } from "./actions/element/updateElementSettings";
import { IMoveSectionActionPayload } from "./actions/section/moveSection";
import { IResizeSectionActionPayload } from "./actions/section/resizeSection";
import { IBringToFrontElementPayload } from "./actions/element/bringToFrontElement";
import { IBringToBackElementPayload } from "./actions/element/bringToBackElement";
import { IUpdateElementStretchActionPayload } from "./actions/element/updateElementStretch";
import { ISelectThemePayload } from "./actions/themes/selectThemeAction";
import { IUpdateGlobalStylesPayload } from "./actions/globalStyles/updateGlobalStyles";

type TWebsiteBuilderDispatch = Dispatch<TWebsiteBuilderAction>;

export function websiteBuilderExitEditor() {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.EXIT_EDITOR,
    });
  };
}

export function websiteBuilderSetDesignMode() {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.SET_DESIGN_MODE,
    });
  };
}

export function websiteBuilderSetPreviewMode() {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.SET_PREVIEW_MODE,
    });
  };
}

export function websiteBuilderLoadThemes() {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.LOAD_THEMES,
      payload: {
        theme: {
          id: 1,
          title: "Cypress Point",
          primary: "#CCA152",
          secondary: "#9DB3BE",
          tertiary: "#58626E",
          quaternary: "#314657",
        },
        availableThemes: [
          {
            id: 2,
            title: "Amen Corner",
            primary: "#383D1F",
            secondary: "#2B4625",
            tertiary: "#929C3B",
            quaternary: "#ABC337",
          },
          {
            id: 3,
            title: "Pebble Beach",
            primary: "#EAB875",
            secondary: "#E1C7A5",
            tertiary: "#D3E3E2",
            quaternary: "#7BC5C1",
          },
          {
            id: 4,
            title: "Pinehurst No. 2",
            primary: "#4C7972",
            secondary: "#915A3C",
            tertiary: "#CFB79F",
            quaternary: "#E8E6E7",
          },
        ],
      },
    });
  };
}

export function websiteBuilderSelectTheme(payload: ISelectThemePayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.SELECT_THEME,
      payload,
    });
  };
}

export function websiteBuilderLoadGlobalStyles() {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.LOAD_GLOBAL_STYLES,
      payload: {
        globalStyles: {
          heading: {
            color: null,
            font: null,
          },
          paragraph: {
            color: null,
            font: null,
            fontSize: null,
          },
          button: {
            color: null,
            backgroundColor: null,
            borderColor: null,
          },
        },
      },
    });
  };
}

export function websiteBuilderUpdateGlobalStyles(payload: IUpdateGlobalStylesPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.UPDATE_GLOBAL_STYLES,
      payload,
    });
  };
}

export function websiteBuilderSelectNode(payload: ISelectNodeActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.SELECT_NODE,
      payload,
    });
  };
}

export function websiteBuilderUpdateSelectedNode(payload: IUpdateSelectedNodeActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.UPDATE_SELECTED_NODE,
      payload,
    });
  };
}

export function websiteBuilderUndo() {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.UNDO,
    });
  };
}

export function websiteBuilderRedo() {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.REDO,
    });
  };
}

export function websiteBuilderAddNode(payload: IAddNodeActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.ADD_NODE,
      payload,
    });
  };
}

export function websiteBuilderDeleteNode(payload: IDeleteNodeActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.DELETE_NODE,
      payload,
    });
  };
}

export function websiteBuilderMoveElement(payload: IMoveElementActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.MOVE_ELEMENT,
      payload,
    });
  };
}

export function websiteBuilderResizeElement(payload: IResizeElementActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.RESIZE_ELEMENT,
      payload,
    });
  };
}

export function websiteBuilderBringToFrontElement(payload: IBringToFrontElementPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.BRING_TO_FRONT_ELEMENT,
      payload,
    });
  };
}

export function websiteBuilderBringToBackElement(payload: IBringToBackElementPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.BRING_TO_BACK_ELEMENT,
      payload,
    });
  };
}

export function websiteBuilderUpdateElementSettings(payload: IUpdateElementSettingsActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.UPDATE_ELEMENT_SETTINGS,
      payload,
    });
  };
}

export function websiteBuilderUpdateElementStretch(payload: IUpdateElementStretchActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.UPDATE_ELEMENT_STRETCH,
      payload,
    });
  };
}

export function websiteBuilderMoveSection(payload: IMoveSectionActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.MOVE_SECTION,
      payload,
    });
  };
}

export function websiteBuilderResizeSection(payload: IResizeSectionActionPayload) {
  return (dispatch: TWebsiteBuilderDispatch) => {
    dispatch({
      type: WebsiteBuilderActionType.RESIZE_SECTION,
      payload,
    });
  };
}
